/** 销售项目类别API */
import type { Api } from '@/typings/api';
import { get, post } from '../../request';
const prefix = '/st/stCategory';
/**
 * 分页查询销售项目类别
 *
 * @param params 查询参数
 */
export const findPage: Api.CommonMethods.FindPage<Api.St.StCategory> = params => {
  return post(`${prefix}/findPage`, params);
};
/**
 * 查询销售项目类别列表
 *
 * @param params 查询参数
 */
export const findAll: Api.CommonMethods.FindAll<Api.St.StCategory> = params => {
  return post(`${prefix}/findAll`, params);
};
/**
 * 查询单个销售项目类别
 *
 * @param id 销售项目类别ID
 * @param column 查询字段
 */
export const findOne: Api.CommonMethods.FindOne<Api.St.StCategory> = (id: string, column?: string[]) => {
  return post(`${prefix}/findOne`, { id, column });
};
/**
 * 保存销售项目类别
 *
 * @param params 销售项目类别信息
 */
export const doSave: Api.CommonMethods.Save = params => {
  return post(`${prefix}/save`, params);
};
/**
 * 更新销售项目类别信息
 *
 * @param params 销售项目类别信息
 */
export const doUpdate: Api.CommonMethods.Update = params => {
  return post(`${prefix}/update`, params);
};
/**
 * 删除销售项目类别
 *
 * @param id 销售项目类别ID
 */
export const doDelete: Api.CommonMethods.Delete = id => {
  return post(`${prefix}/delete?id=${id}`);
};
/**
 * 批量删除销售项目类别
 *
 * @param ids 销售项目类别ID数组
 */
export const doBatchDelete: Api.CommonMethods.BatchDelete = ids => {
  return post(`${prefix}/deleteList`, { ids });
};

export const getAllCategoryOfSection = () => {
  return get(`${prefix}/getAllCategoryOfSection`);
};
export default {
  findPage,
  findOne,
  doSave,
  doUpdate,
  doDelete,
  doBatchDelete,
  getAllCategoryOfSection
};
